import { RoomConfig } from "@/state/RoomConfig/RoomConfig";
import { RoomSizeRestrictions } from "@/utils/useRoomSizeRestrictions";
import { round } from "lodash";
import { Vector2Like } from "three";

export const updateRoomSizeByCursorPoint = (
    wallKey: string,
    roomConfig: RoomConfig,
    target: Vector2Like,
    roomSizeRestrictions: RoomSizeRestrictions
): RoomConfig => {
    const isSideWall = wallKey === roomConfig.leftWall.key || wallKey === roomConfig.rightWall.key;

    if (isSideWall) {
        const minRoomWidth = roomSizeRestrictions.min.width;
        const maxRoomWidth = roomSizeRestrictions.max.width;
        const width = round(
            Math.min(Math.max(minRoomWidth, Math.abs(target.x * 2)), maxRoomWidth),
            3
        );

        return {
            ...roomConfig,
            width,
        };
    } else {
        const minRoomDepth = roomSizeRestrictions.min.depth;
        const maxRoomDepth = roomSizeRestrictions.max.depth;

        const depth = round(
            Math.min(Math.max(minRoomDepth, Math.abs(target.y * 2)), maxRoomDepth),
            3
        );

        return {
            ...roomConfig,
            depth,
        };
    }
};
